import React from "react";
import "./Tulanh.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
const posts = [
  {
    id: 1,
    dateDay: "16",
    dateMonth: "Th6",
    title: "Thay ron tủ lạnh",
    excerpt:
      "Tủ lạnh nhà bạn sử dụng thời gian lâu, đang có dấu hiệu yếu lạnh, [...]",
    image: "/tulanh1.jpeg", // <--- THAY ĐƯỜNG DẪN ẢNH
  },
  {
    id: 2,
    dateDay: "16",
    dateMonth: "Th6",
    title: "Bơm ga tủ lạnh",
    excerpt:
      "Tủ lạnh, sau một thời gian sử dụng mà có những dấu hiệu như tủ [...]",

    image: "/tulanh2.jpg",
  },
  {
    id: 3,
    dateDay: "16",
    dateMonth: "Th6",
    title: "Bảo trì & sửa chữa kho lạnh",
    excerpt:
      "Việc bảo quản các mặt hàng như: thủy hải sản, thực phẩm đông lạnh, [...]",
    image: "/tulanh3.jpg",
  },
];

const latestPosts = [
  "Lắp máy lạnh",
  "Thay ron tủ lạnh hỗ trợ tận nhà",
  "14 hư hỏng khiến tủ lạnh không chạy, không hoạt động",
  "Hướng dẫn sửa tủ lạnh không vào điện",
  "Kinh nghiệm sửa tủ lạnh bị thủng ngăn đá",
];

const services = [
  "Bảo Trì Máy Lạnh Tại Nhà",
  "Bơm Gas Máy Lạnh Tại Nhà",
  "Sửa Máy Giặt Tại Nhà",
  "Bơm Nạp Gas Tủ Lạnh Tại Nhà",
  "Sửa Tủ Lạnh Tại Nhà",
];

export default function Tulanh() {
  return (
    <div className="category-wrapper">
      <Navbar />
      <div className="category-title">
        <h1>LƯU TRỮ DANH MỤC: SỬA TỦ LẠNH</h1>
      </div>

      <div className="category-layout">
        {/* LEFT: LIST BÀI VIẾT */}
        <div className="category-posts">
          {posts.map((post) => (
            <article key={post.id} className="post-card">
              <div className="post-image-wrapper">
                <img src={post.image} alt={post.title} className="post-image" />
                <div className="date-badge">
                  <span className="date-day">{post.dateDay}</span>
                  <span className="date-month">{post.dateMonth}</span>
                </div>
              </div>

              <div className="post-content">
                <h2 className="post-title">{post.title}</h2>
                <p className="post-excerpt">{post.excerpt}</p>
              </div>
            </article>
          ))}
        </div>

        {/* RIGHT: SIDEBAR */}
        <aside className="category-sidebar">
          <div className="sidebar-block">
            <h3 className="sidebar-title">Bài viết mới</h3>
            <ul className="sidebar-list">
              {latestPosts.map((item, idx) => (
                <li key={idx} className="sidebar-item">
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="sidebar-block">
            <h3 className="sidebar-title">Dịch vụ điện lạnh</h3>
            <ul className="sidebar-list">
              {services.map((item, idx) => (
                <li key={idx} className="sidebar-item">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
      <Footer />
    </div>
  );
}
